import { Form, Formik } from 'formik';
import React, { useState } from 'react';
import * as Yup from 'yup';

import { useTeamCreate, useTeamUpdate } from '../../../../hooks';
import { TeamSetting } from '../../../../utils/backend-api/teams';
import { Button } from '../../../BaseUI';
import { TextField } from '../../../FormFields';
import FormErrors from '../../../shared/FormErrors';
import SettingsHeading from '../SettingsHeading';

type FormValuesType = {
  name: string;
};

const validationSchema = () =>
  Yup.object({
    name: Yup.string().required('A name is required'),
  });

export default function NameForm({ teamSetting }: { teamSetting: TeamSetting }) {
  const { updateTeamAsync } = useTeamUpdate();
  const { createTeamAsync } = useTeamCreate();
  const [errors, setErrors] = useState([]);
  const { team } = teamSetting;

  const initialValues: FormValuesType = {
    name: team?.name || '',
  };

  const onSubmit = async (values: FormValuesType) => {
    setErrors([]);
    let resp;
    if (team?.id) {
      resp = await updateTeamAsync({
        name: values.name,
      });
    } else {
      resp = await createTeamAsync({
        name: values.name,
      });
    }
    if (resp.errors) setErrors(resp.errors);
  };

  return (
    <div data-test="team-settings-name">
      <SettingsHeading title="The Information For Your Team">
        Give your team the information and empower them with the information and connections they
        need to win in tech — if you setup a team account, you can add people to your
        &apos;group&apos;, create a custom signup link for your team, or allow anyone with a valid
        email at your team&apos;s domain to access The Information. To get started, enter your team
        name:
      </SettingsHeading>
      <Formik
        initialValues={initialValues}
        onSubmit={onSubmit}
        validationSchema={validationSchema}
        enableReinitialize={true}
      >
        {({ isSubmitting, isValid, dirty }) => (
          <Form>
            <TextField name="name" label="Team Name" placeholder="Enter team name" />
            <FormErrors errors={errors} />
            <Button
              variant="primary"
              className="mt2"
              type="submit"
              disabled={(!isValid && dirty) || isSubmitting}
            >
              {team?.id ? 'Save' : 'Setup Team'}
            </Button>
          </Form>
        )}
      </Formik>
    </div>
  );
}
